
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6a6c5e40&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Designation.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Designation.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6a6c5e40!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Designation.vue"),
  /* scopeId */
  "data-v-6a6c5e40",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/master/Designation.vue
// module id = 728
// module chunks = 0